/* Max per order for products that otherwise ship as more than one parcel.
   Keep this list in sync with snippets/order-qty-limit.liquid. */
(function () {
  var LIMITS = {
    "51381603139923": { handle: "isfritt-pro-12-5-l", max: 2, title: "Isfritt PRO 12,5 L" },
    "51669187199315": { handle: "isfritt-easy-12-5-l", max: 2, title: "Isfritt EASY 12,5 L" },
    "51669187035475": { handle: "isfritt-eco-12-5l", max: 2, title: "Isfritt ECO 12,5L" },
    "51669186707795": { handle: "isfritt-easy-5l", max: 4, title: "Isfritt EASY 5L" },
    "51644723495251": { handle: "isfritt-pro-5-5-l", max: 4, title: "Isfritt PRO 5,5 L" },
    "51644724281683": { handle: "isfritt-pro-ergo-4l-strokanna-4st-lada", max: 4, title: "Isfritt PRO Ergo 4L Strökanna 4st/låda" }
  };

  var originalFetch = window.fetch.bind(window);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var english = (window.Shopify && Shopify.locale || "").indexOf("en") === 0;

  function message(title, max) {
    if (english) {
      return "You can order at most " + max + " of " + title + " per order, so the delivery fits in one parcel.";
    }
    return "Du kan beställa högst " + max + " st av " + title + " per order, så att leveransen ryms i ett paket.";
  }

  function reject(description) {
    return new Response(JSON.stringify({
      status: 422,
      message: description,
      description: description
    }), {
      status: 422,
      headers: { "Content-Type": "application/json" }
    });
  }

  function cartAction(url) {
    try {
      var path = new URL(url, window.location.origin).pathname;
      if (path.endsWith("/cart/add.js")) return "add";
      if (path.endsWith("/cart/change.js")) return "change";
      if (path.endsWith("/cart/update.js")) return "update";
    } catch (error) {}
    return null;
  }

  function ruleForVariant(variantId) {
    return LIMITS[String(variantId)] || null;
  }

  function ruleForItem(item) {
    return ruleForVariant(item.variant_id) || null;
  }

  async function getCart() {
    var response = await originalFetch(root + "cart.js", {
      headers: { Accept: "application/json" }
    });
    return response.json();
  }

  async function readBody(init) {
    if (!init || init.body == null) return null;
    if (typeof init.body === "string") {
      try {
        return { type: "json", data: JSON.parse(init.body) };
      } catch (error) {
        return null;
      }
    }
    if (typeof FormData !== "undefined" && init.body instanceof FormData) {
      return { type: "form", data: init.body };
    }
    if (typeof URLSearchParams !== "undefined" && init.body instanceof URLSearchParams) {
      return { type: "params", data: init.body };
    }
    return null;
  }

  function requestedAdds(parsed) {
    var adds = [];
    if (!parsed) return adds;

    if (parsed.type === "form" || parsed.type === "params") {
      var id = parsed.data.get("id");
      var quantity = parseInt(parsed.data.get("quantity") || "1", 10);
      if (id) adds.push({ variantId: String(id), quantity: quantity || 1 });
      return adds;
    }

    var data = parsed.data || {};
    if (Array.isArray(data.items)) {
      data.items.forEach(function (item) {
        if (item && item.id) {
          adds.push({
            variantId: String(item.id),
            quantity: parseInt(item.quantity || 1, 10) || 1
          });
        }
      });
    } else if (data.id) {
      adds.push({
        variantId: String(data.id),
        quantity: parseInt(data.quantity || 1, 10) || 1
      });
    }
    return adds;
  }

  function quantityInCart(cart, variantId, exceptKey) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (exceptKey && item.key === exceptKey) return;
      if (String(item.variant_id) === String(variantId)) total += item.quantity;
    });
    return total;
  }

  async function check(action, init) {
    var parsed = await readBody(init);

    if (action === "add") {
      var adds = requestedAdds(parsed).filter(function (add) {
        return ruleForVariant(add.variantId);
      });
      if (!adds.length) return null;
      var cart = await getCart();
      for (var i = 0; i < adds.length; i++) {
        var rule = ruleForVariant(adds[i].variantId);
        var next = quantityInCart(cart, adds[i].variantId) + adds[i].quantity;
        if (next > rule.max) return message(rule.title, rule.max);
      }
      return null;
    }

    if (!parsed || parsed.type !== "json") return null;
    var data = parsed.data || {};

    if (action === "change" && data.id != null && data.quantity != null) {
      var cartForChange = await getCart();
      var line = (cartForChange.items || []).find(function (item) {
        return item.key === String(data.id) || String(item.variant_id) === String(data.id);
      });
      var variantId = line ? line.variant_id : String(data.id).split(":")[0];
      var changeRule = ruleForVariant(variantId);
      if (!changeRule) return null;
      var nextQty = quantityInCart(cartForChange, variantId, line && line.key) + (parseInt(data.quantity, 10) || 0);
      if (nextQty > changeRule.max) return message(line ? line.product_title : changeRule.title, changeRule.max);
      return null;
    }

    if (action === "update" && data.updates) {
      var cartForUpdate = await getCart();
      var keys = Object.keys(data.updates);
      for (var u = 0; u < keys.length; u++) {
        var key = keys[u];
        var updateLine = (cartForUpdate.items || []).find(function (item) {
          return item.key === key || String(item.variant_id) === String(key);
        });
        var updateVariant = updateLine ? updateLine.variant_id : String(key).split(":")[0];
        var updateRule = ruleForVariant(updateVariant);
        if (!updateRule) continue;
        var updated = quantityInCart(cartForUpdate, updateVariant, updateLine && updateLine.key) + (parseInt(data.updates[key], 10) || 0);
        if (updated > updateRule.max) return message(updateLine ? updateLine.product_title : updateRule.title, updateRule.max);
      }
    }

    return null;
  }

  window.fetch = async function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var action = cartAction(url);
    if (action) {
      try {
        var error = await check(action, init);
        if (error) return reject(error);
      } catch (error) {}
    }
    return originalFetch.apply(this, arguments);
  };

  document.addEventListener("click", function (event) {
    var button = event.target.closest && event.target.closest(".quantity-selector__button");
    if (!button) return;
    var selector = button.closest("quantity-selector");
    var input = selector && selector.querySelector("input");
    if (!input || input.max === "") return;
    var buttons = selector.querySelectorAll("button");
    var isIncrease = button === buttons[buttons.length - 1];
    if (isIncrease && parseInt(input.value, 10) >= parseInt(input.max, 10)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  async function clampExistingCart() {
    var cart = await getCart();
    var changed = false;
    var groups = {};

    (cart.items || []).forEach(function (item) {
      var rule = ruleForItem(item);
      if (!rule) return;
      groups[rule.handle] = groups[rule.handle] || { max: rule.max, items: [] };
      groups[rule.handle].items.push(item);
    });

    var handles = Object.keys(groups);
    for (var i = 0; i < handles.length; i++) {
      var group = groups[handles[i]];
      var remaining = group.max;
      for (var j = 0; j < group.items.length; j++) {
        var item = group.items[j];
        var next = Math.min(item.quantity, Math.max(remaining, 0));
        remaining -= next;
        if (next !== item.quantity) {
          changed = true;
          await originalFetch(root + "cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: item.key, quantity: next })
          });
        }
      }
    }

    if (changed) window.location.reload();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      clampExistingCart().catch(function () {});
    });
  } else {
    clampExistingCart().catch(function () {});
  }
})();
